module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "sports2.28e7851c.png";